import { IconAI, IconCloudUpload, IconInfo, IconMessage, IconSubtitles, IconUsers } from '../base/icons/svg';
import { SidePanelTabId } from './constants';
/**
 * 侧栏应用标题与图标（桌面页签栏、浮窗标题、手机抽屉标题共用）.
 */
export const SIDE_PANEL_TAB_META = {
    [SidePanelTabId.AI_NOTES]: {
        icon: IconAI,
        labelKey: 'sidePanel.tabs.aiNotes'
    },
    [SidePanelTabId.CHAT]: {
        icon: IconMessage,
        labelKey: 'sidePanel.tabs.chat'
    },
    [SidePanelTabId.CLOSED_CAPTIONS]: {
        icon: IconSubtitles,
        labelKey: 'sidePanel.tabs.closedCaptions'
    },
    [SidePanelTabId.CUSTOM_PANEL]: {
        icon: IconMessage,
        labelKey: 'sidePanel.tabs.customPanel'
    },
    [SidePanelTabId.FILE_SHARING]: {
        icon: IconCloudUpload,
        labelKey: 'sidePanel.tabs.fileSharing'
    },
    [SidePanelTabId.PARTICIPANTS]: {
        icon: IconUsers,
        labelKey: 'sidePanel.tabs.participants'
    },
    [SidePanelTabId.POLLS]: {
        icon: IconInfo,
        labelKey: 'sidePanel.tabs.polls'
    }
};
